import { Component, Input, ViewChild, ElementRef, ChangeDetectorRef, Renderer, OnChanges, SimpleChanges, Output, EventEmitter } from '@angular/core';
import { DomController } from 'ionic-angular';


/**
 * Generated class for the CircleComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'custom-circle',
  templateUrl: 'custom-circle.html'
})
export class CustomCircleComponent implements OnChanges {

  @ViewChild('contenedor') contenedor: ElementRef;

  // color draw
  @Input() color: string;

  @Input() name: string;

  // punto central || top left corner?? 
  @Input() x: number;
  @Input() y: number;


  @Input() scroll: number;

  // diametro circulo
  @Input() diametro: number;

  // drag zone
  @Input() dragZoneWidth: number;
  @Input() dragZoneHeight: number;

  // seleccionado
  @Input() selected: boolean = false;

  // longitud de las lineas con respecto al diametro
  private lineLengthPercent: number = 1.50;



  @Output() newPosition: EventEmitter<any> = new EventEmitter<any>();


  hola(event) {
   // alert("ASSSSSYESS")
  }

  cambioPosicion(event) {
    console.log(this.scroll + "SCROLL CONTROL")
  this.x = event.x// + (this.dragZoneWidth / 2);
   this.y = event.y// + (this.dragZoneHeight / 2);
   // this.x = event.x + (this.dragZoneWidth / 2);
    //this.y = event.y + (this.dragZoneHeight / 2);
    this.newPosition.emit({
      name: this.name,
      position: {
        x: event.x,
        y: event.y
      }
    })
  }

  constructor(private renderer: Renderer, private domCtrl: DomController) {
  }


  ngOnChanges(changes: SimpleChanges): void {
    console.log(this.scroll + "SCROLL CONTROL")
    this.domCtrl.write(() => {
  
      if (changes.x) {
        let x = changes.x.currentValue// - (this.dragZoneWidth / 2)
        this.renderer.setElementStyle(this.contenedor.nativeElement, 'left', x + 'px');
      }
      if (changes.y) {
        let y = changes.y.currentValue// - (this.dragZoneHeight / 2)
        this.renderer.setElementStyle(this.contenedor.nativeElement, 'top', y + 'px');
      }
      if (changes.selected) this.renderer.setElementStyle(this.contenedor.nativeElement, 'border', '1px solid ' + (changes.selected.currentValue ? 'white' : 'black'));
    });
  }


}



// WEBPACK FOOTER //
// ./src/components/custom-circle/custom-circle.ts